const initIframeCSS = () => {

    function checkIframe0() {
        let iframe = document.getElementById('hs-form-iframe-0');
        if (iframe) {
            clearInterval(checkInterval0); // Stop the periodic check
            // Insert the code we want to execute once the iframe is present
            addCssToIframe(iframe);
            addSubmitButton(iframe);
        }
    }

    /*
    function checkIframe1() {
        let iframe = document.getElementById('hs-form-iframe-1');
        if (iframe) {
            clearInterval(checkInterval1); // Stop the periodic check
            // Insert the code we want to execute once the iframe is present
            addCssToIframe(iframe);
            addSubmitButton(iframe);
        }
    }
    */
    
    // Interval for periodic check
    let checkInterval0 = setInterval(checkIframe0, 100); // Check every ...
    //let checkInterval1 = setInterval(checkIframe1, 100);
    
    // Function to add CSS file to iframe
    function addCssToIframe(iframe) {
        let innerDoc = iframe.contentDocument || iframe.contentWindow.document;
        let link = innerDoc.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = '../../wp-content/themes/bfa/dist/css/style.css';  // SET PATH TO style.css FILE
        innerDoc.head.appendChild(link);
        innerDoc.body.classList.add('iframe-body');
    }

    function addSubmitButton(iframe) {
        let innerDoc = iframe.contentDocument || iframe.contentWindow.document;
    
        let checkInterval = setInterval(function() {
            let submitButton = innerDoc.body.querySelector('div.actions');
            if (submitButton) {
                let submitButtonText = submitButton.querySelector('input').value;
                let newSubmitButton = innerDoc.createElement('button');
    
                newSubmitButton.classList.add('cs-button-submit');
                newSubmitButton.innerHTML = submitButtonText;
    
                submitButton.appendChild(newSubmitButton);
                clearInterval(checkInterval); // Stop the periodic check
            }
        }, 100); // Check every ...
    }
}

export { initIframeCSS }
